import React from 'react';
import { SvgIcon } from '@material-ui/core';

const SecondStepIcon = (props) => (
  <SvgIcon
    width="35.273"
    height="46.958"
    viewBox="0 0 35.273 46.958"
    {...props}
  >
    <g id="Palier2" transform="translate(-35.656 -29.755)">
      <g id="Groupe_6160" transform="translate(22.781 33.943)">
        <path
          id="Tracé_3733"
          d="M16.316 19.136a4.021 4.021 0 0 0 1.6 3.2.291.291 0 0 1 .055.342 4 4 0 0 0 3.168 5.488.313.313 0 0 1 .205.115l.089 14.485 4.33-2.44 4.359 2.387-.058-9.467c.127.012.254.023.382.023s.254-.01.38-.023l.039 6.394L35.2 37.2l4.359 2.387-.069-11.174a.308.308 0 0 1 .267-.248 4 4 0 0 0 3.169-5.488.291.291 0 0 1 .055-.341 4 4 0 0 0 0-6.406.291.291 0 0 1-.055-.342 4 4 0 0 0-3.167-5.488.31.31 0 0 1-.276-.276A4 4 0 0 0 34 6.66a.292.292 0 0 1-.342-.056 3.968 3.968 0 0 0-3.2-1.6 4.018 4.018 0 0 0-3.2 1.6.291.291 0 0 1-.342.056 4 4 0 0 0-5.488 3.168.311.311 0 0 1-.276.276 4 4 0 0 0-3.168 5.488.292.292 0 0 1-.055.341 4.02 4.02 0 0 0-1.613 3.203zm6.869 20.624l-.052-8.547c.083.056.164.115.252.165a3.993 3.993 0 0 0 1.672.522l.062 6.769zm3.21-1.1l-.063-6.865a4.029 4.029 0 0 0 .577-.183.291.291 0 0 1 .342.055 3.987 3.987 0 0 0 1.052.972l.044 7.089zm6.224-2.026l-.024-3.99a3.992 3.992 0 0 0 1.062-.977.291.291 0 0 1 .343-.055 4.1 4.1 0 0 0 .582.184l.034 3.714zm3.146-1.134l-.033-3.592a3.984 3.984 0 0 0 1.788-.53c.078-.045.151-.1.225-.147l.033 5.372zM18.978 17.346a2.046 2.046 0 0 0 .629-2.426 2.234 2.234 0 0 1 1.771-3.068 2.065 2.065 0 0 0 1.791-1.79 2.234 2.234 0 0 1 3.067-1.771 2.046 2.046 0 0 0 2.426-.63 2.234 2.234 0 0 1 3.58 0 2.046 2.046 0 0 0 2.426.63 2.234 2.234 0 0 1 3.068 1.771 2.064 2.064 0 0 0 1.79 1.79A2.235 2.235 0 0 1 41.3 14.92a2.045 2.045 0 0 0 .63 2.426 2.234 2.234 0 0 1 0 3.58 2.046 2.046 0 0 0-.629 2.426 2.235 2.235 0 0 1-1.771 3.068 2.064 2.064 0 0 0-1.789 1.79 2.235 2.235 0 0 1-3.068 1.771 2.045 2.045 0 0 0-2.426.63 2.235 2.235 0 0 1-3.581 0 2 2 0 0 0-1.611-.791 2.141 2.141 0 0 0-.814.162 2.235 2.235 0 0 1-3.068-1.771 2.064 2.064 0 0 0-1.79-1.79 2.234 2.234 0 0 1-1.771-3.067 2.045 2.045 0 0 0-.63-2.426 2.234 2.234 0 0 1 0-3.581z"
        />
        <path
          id="Tracé_3734"
          d="M37.115 35.118A9.317 9.317 0 1 0 27.8 25.8a9.327 9.327 0 0 0 9.315 9.318zm0-17.222A7.905 7.905 0 1 1 29.21 25.8a7.914 7.914 0 0 1 7.905-7.9z"
          transform="translate(-6.663 -6.665)"
        />
        <path
          id="Tracé_3735"
          d="M37.329 35.537l3.914-1.392 3.914 1.392-.114-4.152 2.533-3.292-3.984-1.175-2.348-3.426-2.348 3.426-3.986 1.175 2.533 3.292zm-.17-6.714l2.57-.757 1.514-2.209 1.515 2.21 2.57.757-1.634 2.123.074 2.678-2.525-.9-2.524.9.074-2.678z"
          transform="translate(-10.791 -10.732)"
        />
      </g>
      <rect
        id="Rectangle_1383"
        width="1.761"
        height="6.305"
        rx=".88"
        transform="translate(52.293 29.755)"
      />
      <rect
        id="Rectangle_1384"
        width="1.761"
        height="6.305"
        rx=".88"
        transform="translate(42.398 32.829) rotate(-30)"
      />
      <rect
        id="Rectangle_1385"
        width="1.761"
        height="6.305"
        rx=".88"
        transform="translate(60.918 38.29) rotate(-150)"
      />
      <rect
        id="Rectangle_1386"
        width="1.761"
        height="6.305"
        rx=".88"
        transform="translate(65.469 42.967) rotate(-120)"
      />
      <rect
        id="Rectangle_1387"
        width="1.761"
        height="6.305"
        rx=".881"
        transform="translate(35.656 39.814) rotate(-60)"
      />
    </g>
  </SvgIcon>
);

export default SecondStepIcon;
